export const emits = [
  'click',
];
